import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import {
  Grid,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TablePagination,
  TableBody
} from '@material-ui/core'
import { rewardCostTypeMapping, rewardPrizeTypeMapping, rewardPrizeTypeValueMapping } from '../../constant'
import { priceFormat } from '../../utils/priceFormat'


@inject('ActivityStore', 'ShopStore')
@observer
class PointsRedeemActivity extends Component {

  componentDidMount() {
    this.props.ActivityStore.fetchPointsRedeem()
  }

  handlePageChange = (e, page) => {
    this.props.ActivityStore.pointsRedeemPageOnChange(page)
  }

  handleChangeRowsPerPage = e => {
    this.props.ActivityStore.pointsRedeemPageSizeOnChange(e.target.value)
  }

  formatReward = (prizeType, prizeValue) => {
    if (prizeType === rewardPrizeTypeValueMapping.amount) {
      const value = priceFormat(prizeValue, this.props.ShopStore.shop)
      return `${value}${rewardPrizeTypeMapping[prizeType]}`
    }
    return `${prizeValue}${rewardPrizeTypeMapping[prizeType]}`
  }

  render() {

    const { pointsRedeemQuery, pointsRedeemPage, pointsRedeem } = this.props.ActivityStore
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    Customer
                  </TableCell>
                  <TableCell>
                    Action
                  </TableCell>
                  <TableCell align='right'>
                    Points
                  </TableCell>
                  <TableCell align='right'>
                    Rewards
                  </TableCell>
                  <TableCell align='right'>
                    Date
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
              {pointsRedeem.map(item => (
                <TableRow key={item.id}>
                  <TableCell>
                    {item.first_name} {item.last_name}
                  </TableCell>
                  <TableCell>
                    {rewardCostTypeMapping[item.cost_type]}
                  </TableCell>
                  <TableCell align='right'>
                    -{item.cost_value}
                  </TableCell>
                  <TableCell align='right'>
                    {this.formatReward(item.prize_type, item.prize_value)}
                  </TableCell>
                  <TableCell align='right'>
                    {new Date(item.created).toLocaleString()}
                  </TableCell>
                </TableRow>
              ))}
              </TableBody>
            </Table>
            
            <TablePagination 
              rowsPerPageOptions={[15, 30, 100]}
              component='div'
              count={pointsRedeemQuery.count}
              rowsPerPage={pointsRedeemQuery.limit}
              page={pointsRedeemPage}
              onChangePage={this.handlePageChange}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
          </Paper>
        </Grid>
      </Grid>
    )
  }
}
export default PointsRedeemActivity